import { Link, useLocation } from "react-router-dom";

/**
 * Strip d'onglets réutilisable pour regrouper plusieurs pages liées
 * sous une même section. Préserve les fonctionnalités existantes en
 * navigant simplement entre les routes.
 *
 * Usage :
 *   <SectionTabs tabs={[
 *     { path: "/log/creances", label: "À encaisser" },
 *     { path: "/log/payment-tracking", label: "Reçus" }
 *   ]} />
 */
export default function SectionTabs({ tabs }) {
  const location = useLocation();
  // Decode URL-encoded pathnames (e.g. /log/ia-pr%C3%A9dictive -> /log/ia-prédictive)
  // so comparison with literal route paths containing accented chars works.
  let currentPath = location.pathname;
  try {
    currentPath = decodeURIComponent(location.pathname);
  } catch (e) {
    // ignore malformed URI
  }
  return (
    <div className="flex items-center gap-1 mb-5 border-b border-slate-200 overflow-x-auto" data-testid="section-tabs">
      {tabs.map((t) => {
        const isActive = currentPath === t.path;
        return (
          <Link
            key={t.path}
            to={t.path}
            data-testid={`section-tab-${t.path.split("/").pop()}`}
            className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
              isActive
                ? "border-blue-600 text-blue-700"
                : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
            }`}
          >
            {t.icon && <t.icon className="w-4 h-4 inline mr-1.5 -mt-0.5" />}
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}

// Définitions des sections regroupées
import { Wallet, CheckCircle2, Truck, ClipboardList, Send, BarChart3, CalendarCheck, Zap, List, GitBranch } from "lucide-react";

export const INVOICES_TABS = [
  { path: "/log/invoices", label: "Vue Liste", icon: List },
  { path: "/log/pipeline", label: "Vue Pipeline", icon: GitBranch },
];

export const FINANCE_TABS = [
  { path: "/log/creances", label: "À encaisser", icon: Wallet },
  { path: "/log/payment-tracking", label: "Reçus", icon: CheckCircle2 },
];

export const TOURS_TABS = [
  { path: "/log/expeditions", label: "Expéditions", icon: Send },
  { path: "/log/courses", label: "Courses", icon: Truck },
  { path: "/log/bordereaux", label: "Bordereaux", icon: ClipboardList },
];

export const ANALYTICS_TABS = [
  { path: "/log/analytics", label: "Performance", icon: BarChart3 },
  { path: "/log/rapport-mensuel", label: "Rapport mensuel", icon: CalendarCheck },
  { path: "/log/ia-prédictive", label: "Prédictions IA", icon: Zap },
];
